import { TemporaryPermissionStatus } from "@/api-schema-enums";
import { Button, ButtonColorVariant, ButtonSize, ButtonVariant } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectSeparator, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useTranslation } from "react-i18next";
import { StatusCell } from "./status-cell";

export interface StatusSelectProps {
  value?: string;
  onValueChange?: (value: string | undefined) => void;
}

export function StatusSelect({ value = "", onValueChange }: StatusSelectProps) {
  const { t } = useTranslation(["ram", "common"]);

  const handleChange = (next: string) => {
    onValueChange?.(next);
  };

  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation();
    onValueChange?.(undefined);
  };

  return (
    <Select value={value} onValueChange={handleChange}>
      <SelectTrigger className="h-9 w-40">
        <SelectValue placeholder={<span className="text-foreground/75">{t("common:Status")}</span>} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={TemporaryPermissionStatus.Pending}>
          <div className="flex items-center gap-2">
            <StatusCell status={TemporaryPermissionStatus.Pending} />
            <span>{t("ram:Pending")}</span>
          </div>
        </SelectItem>
        <SelectItem value={TemporaryPermissionStatus.Approved}>
          <div className="flex items-center gap-2">
            <StatusCell status={TemporaryPermissionStatus.Approved} />
            <span>{t("ram:Approved")}</span>
          </div>
        </SelectItem>
        <SelectItem value={TemporaryPermissionStatus.Rejected}>
          <div className="flex items-center gap-2">
            <StatusCell status={TemporaryPermissionStatus.Rejected} />
            <span>{t("ram:Rejected")}</span>
          </div>
        </SelectItem>
        <SelectSeparator />
        <Button
          className="w-full px-2"
          variant={ButtonVariant.Filled}
          colorVariant={ButtonColorVariant.Secondary}
          size={ButtonSize.Sm}
          onClick={handleClear}
        >
          {t("common:Clear")}
        </Button>
      </SelectContent>
    </Select>
  );
}
